import moment from "moment";
import dashboardIcon from "../Images/Leaderboard.svg";
import crmIcon from "../Images/CRM.svg";
import setupMiniStore from "../Images/website-design.svg";
import miniStore from "../Images/web.svg";
import orderIcon from "../Images/orders.svg";
import productIcon from "../Images/Product.svg";
import accountingIcon from "../Images/Sales.svg";
import warehouseIcon from "../Images/Warehouse.svg";
import contactIcon from "../Images/Contact.svg";
import subscriptionIcon from "../Images/subscription.svg";
import settingIcon from "../Images/Settings.svg";
import Contactsicon from "../Images/Contacts.svg";
import UserImg from "../Images/userIcon.svg";
import CompanyIcon from "../Images/Building.svg";
import PoSIcon from "../Images/pointOfSale.svg";

// <========================= ENV ==================================>

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const DB_NAME = process.env.REACT_APP_API_DB_NAME;
export const COMPANY_DOMAIN = process.env.REACT_APP_API_COMPANY_DOMAIN;

// <========================= CONSTANTS ==================================>

// REGEX
export const PHONE_NUMBER_REGEX = /^[+0-9( )-]*$/;

export const DOMAIN_NAME_REGEX =
  /^(?!.[&'@()A-Z,.! ?_#\$^\\/:;%+=<>\[\]])[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*$/;

export const POLL_WAIT_TIME = 3000; //in ms
export const PAGINATION_DEFAULT_LIMIT = 15;
export const PAGINATION_DEFAULT_LIMIT_FOR_DROPDOWN = 10;

export const DISPLAY_DATE_FORMAT = "DD MMM YYYY";
export const SCHEDULE_ACTIVITY_INPUT_DATE_FORMAT = "YYYY-MM-DD";
export const ADD_SALE_ORDER_DATE_FORMAT = "YYYY-MM-DD hh:mm:ss";
export const SUBSCRIPTION_VIEW_DATE_FORMAT = "MM/DD/YY";

export const GET_LEAD_DETAIL_KEYS = [
  "show_enrich_button",
  "stage_id",
  "ribbon_message",
  "active",
  "meeting_count",
  "quotation_count",
  "sale_amount_total",
  "sale_order_count",
  "visitor_page_count",
  "name",
  "company_currency",
  "expected_revenue",
  "automated_probability",
  "is_automated_probability",
  "probability",
  "partner_id",
  "partner_name",
  "street",
  "street2",
  "city",
  "state_id",
  "zip",
  "country_id",
  "website",
  "lang_id",
  "is_blacklisted",
  "partner_is_blacklisted",
  "phone_blacklisted",
  "mobile_blacklisted",
  "email_state",
  "phone_state",
  "email_from",
  "otp_to_be_verified",
  "email_verified",
  "otp",
  "phone",
  "contact_name",
  "title",
  "email_cc",
  "function",
  "mobile",
  "date_deadline",
  "priority",
  "tag_ids",
  "user_id",
  "team_id",
  "type",
  "lost_reason",
  "date_conversion",
  "company_id",
  "description",
  "message_bounce",
  "campaign_id",
  "medium_id",
  "source_id",
  "referred",
  "date_open",
  "date_closed",
  "day_open",
  "day_close",
  "message_follower_ids",
  "activity_ids",
  "message_ids",
  "display_name",
];
export const SALE_ORDER_DETAIL_KEYS = [
  "authorized_transaction_ids",
  "disabled_confirm_button",
  "state",
  "picking_ids",
  "delivery_count",
  "invoice_count",
  "name",
  "partner_id",
  "delivery_set",
  "is_all_service",
  "recompute_delivery_price",
  "partner_invoice_id",
  "partner_shipping_id",
  "sale_order_template_id",
  "validity_date",
  "date_order",
  "show_update_pricelist",
  "pricelist_id",
  "currency_id",
  "payment_term_id",
  "payment_status",
  "order_line",
  "note",
  "amount_untaxed",
  "amount_tax",
  "amount_total",
  "sale_order_option_ids",
  "user_id",
  "process_manual_confirm",
  "team_id",
  "website_id",
  "is_abandoned_cart",
  "cart_recovery_email_sent",
  "company_id",
  "require_signature",
  "require_payment",
  "reference",
  "client_order_ref",
  "tag_ids",
  "related_enable_contact_map_support",
  "location_map_latitude",
  "location_map_longitude",
  "location_map_url",
  "fiscal_position_id",
  "analytic_account_id",
  "invoice_status",
  "warehouse_id",
  "incoterm",
  "picking_policy",
  "commitment_date",
  "expected_date",
  "show_json_popover",
  "json_popover",
  "effective_date",
  "origin",
  "opportunity_id",
  "campaign_id",
  "medium_id",
  "source_id",
  "signed_by",
  "signed_on",
  "signature",
  "__last_update",
  "message_follower_ids",
  "activity_ids",
  "message_ids",
  "display_name",
];
export const BANk_LINE_DETAIL_KEYS = [
  "sequence",
  "bank_id",
  "acc_number",
  "branch_name",
  "acc_holder_name",
  "cr_img",
  "vc_img",
  "cc_img",
  "cr_number",
  "cr_expiry_date",
  "vat_number",
  "vat_expiry_date",
];
export const CONTRACT_LINE_DETAIL_KEYS = [
  "id",
  "date_start",
  "attachment_id",
  "contract_status",
];
export const USER_LINE_DETAIL_KEYS = [
  "id",
  "name",
  "email",
  "login",
  "designation",
  "phone",
];
export const ORDER_LINE_DETAIL_KEYS = [
  "sequence",
  "display_type",
  "product_uom_category_id",
  "product_updatable",
  "product_id",
  "product_template_id",
  "name",
  "analytic_tag_ids",
  "route_id",
  "product_uom_qty",
  "qty_delivered",
  "product_type",
  "virtual_available_at_date",
  "qty_available_today",
  "free_qty_today",
  "scheduled_date",
  "forecast_expected_date",
  "warehouse_id",
  "qty_to_deliver",
  "is_mto",
  "display_qty_widget",
  "qty_delivered_manual",
  "qty_delivered_method",
  "qty_invoiced",
  "qty_to_invoice",
  "product_uom_readonly",
  "product_uom",
  "customer_lead",
  "product_packaging",
  "recompute_delivery_price",
  "is_delivery",
  "price_unit",
  "tax_id",
  "discount",
  "price_subtotal",
  "price_total",
  "state",
  "invoice_status",
  "currency_id",
  "price_tax",
  "company_id",
];

export const USER_DETAIL_KEYS = [
  "name",
  "login",
  "password",
  "new_password",
  "lang",
  "login_date",
  "state",
  "company_id",
  "totp_enabled",
  "image_1920",
  "designation",
  "phone",
  "groups_id",
];
export const ACTIVE_SOCIAL_MEDIA_KEYS = [
  "selected",
  "ayrshare_id",
  "company_id",
  "display_name",
];
export const COMPANY_DETAIL_KEYS = [
  "logo",
  "__last_update",
  "partner_gid",
  "name",
  "partner_id",
  "street",
  "street2",
  "city",
  "state_id",
  "zip",
  "country_id",
  "country_code",
  "phone",
  "email",
  "sales_notify_template_id",
  "enable_contact_map_support",
  "website",
  "vat",
  "company_registry",
  "currency_id",
  "parent_id",
  "sequence",
  "favicon",
  "social_twitter",
  "social_facebook",
  "social_github",
  "social_linkedin",
  "social_youtube",
  "social_instagram",
  "connected",
  "active_social_media_lines",
  "instagram_analytics",
  "facebook_analytics",
  "twitter_analytics",
  "bank_ids",
  "subscription_id",
  "display_name",
];

export const PRODUCT_DETAILS_KEYS = [
  "name",
  "image_1920",
  "sale_ok",
  "purchase_ok",
  "is_litecommerce",
  "litecommerce_count",
  "is_category_product",
  "brand_id",
  // "available_in_pos",
  "company_id",
  // general
  "type",
  "categ_id",
  "list_price",
  "taxes_id",
  "standard_price",
  "vtex_product_id",
  "barcode",
  "hs_code",
  "weight",
  "ProHeight",
  "ProWidth",
  "ProLength",
  "volume",
  "qty_available",
  "sale_delay",
  // "related_products_id",
  "description_sale",
  "product_template_image_ids",
  // ecomerece
  "public_categ_ids",
  "alternative_product_ids",
  "VtexAttrsIds",
  // product image
  "social_image_1920",
  // variants
  "attribute_line_ids",

  // additional
  "product_variant_ids",
  "is_published",
  // "available_in_pos",
  // "product_variant_count",
  // "is_product_variant",
  // "show_on_hand_qty_status_button",
  // "qty_available",
  // "uom_name",
  // "virtual_available",
  // "reordering_min_qty",
  // "reordering_max_qty",
  // "nbr_reordering_rules",
  // "sales_count",
  // "id",
  // "image_1920",
  // "__last_update",
  // "name",
  // "sale_ok",
  // "purchase_ok",
  // "active",
  // "type",
  // "categ_id",
  // "default_code",
  // "barcode",
  // "list_price",
  // "pricelist_item_count",
  // "taxes_id",
  // "standard_price",
  // "company_id",
  // "uom_id",
  // "uom_po_id",
  // "currency_id",
  // "cost_currency_id",
  // "product_variant_id",
  // "description",
  // "invoice_policy",
  // "service_type",
  // "visible_expense_policy",
  // "expense_policy",
  // "description_sale",
  // "sale_line_warn",
  // "sale_line_warn_msg",
  // "website_url",
  // "website_id",
  // "website_sequence",
  // "public_categ_ids",
  // "inventory_availability",
  // "available_threshold",
  // "custom_message",
  // "alternative_product_ids",
  // "accessory_product_ids",
  // "website_ribbon_id",
  // "supplier_taxes_id",
  // "has_available_route_ids",
  // "route_ids",
  // "route_from_categ_ids",
  // "responsible_id",
  // "weight",
  // "weight_uom_name",
  // "volume",
  // "volume_uom_name",
  // "sale_delay",
  // "hs_code",
  // "tracking",
  // "property_stock_production",
  // "property_stock_inventory",
  // "packaging_ids",
  // "description_pickingout",
  // "description_pickingin",
  // "description_picking",
  // "property_account_income_id",
  // "property_account_expense_id",
  // "message_follower_ids",
  // "activity_ids",
  // "message_ids",
  // "display_name",
];
export const MINI_STORE_PAGINATION_LIMIT = 12;
export const CART_LIST = [
  {
    name: "name",
    title: "Products",
  },
  {
    name: "lst_price",
    title: "Price",
  },
  {
    name: "qty",
    title: "Quantity",
  },
  {
    name: "total",
    title: "Total",
  },
  {
    name: "delete_icon",
    title: "",
  },
];
export const EXPLORE_BTNS_MINI_STORE = [
  {
    title: "Top Selling",
    path: "top-selling",
  },
  {
    title: "New Arrivals",
    path: "new-arrivals",
  },
  {
    title: "Exclusive Discounts",
    path: "exclusive-discounts",
  },
  {
    title: "Limited Stock",
    path: "limited-stock",
  },
  // {
  //   title: "Trending Now",
  //   path: "trending-now",
  // },
];
export const DEFAULT_PALETTES = [
  {
    template: "Template 1",
    hex: ["#F1C40F", "#01ACAB", "#FAE8E0", "#FFFFFF", "#000000"],
  },
  {
    template: "Template 2",
    hex: ["#01ACAB", "#F1C40F", "#FAE8E0", "#FFFFFF", "#000000"],
  },
  {
    template: "Template 3",
    hex: ["#85AFA8", "#7E566B", "#85909A", "#969397", "#422335"],
  },
  {
    template: "Template 4",
    hex: ["#54787D", "#6B9997", "#614D45", "#C6CCA5", "#412344"],
  },
  {
    template: "Template 5",
    hex: ["#984C46", "#23323B", "#ECEAE4", "#FFFFFF", "#16121F"],
  },
  {
    template: "Template 6",
    hex: ["#B99932", "#DED1C1", "#F5F5F5", "#FFFFFF", "#373737"],
  },
  {
    template: "Template 7",
    hex: ["#F8882F", "#6A7C8F", "#FDF8EF", "#FFFFFF", "#212C39"],
  },
  {
    template: "Template 8",
    hex: ["#6E7993", "#98648C", "#8F9A9F", "#D5D5D5", "#313347"],
  },
  {
    template: "Template 9",
    hex: ["#F7CF41", "#1A2930", "#989898", "#FFFFFF", "#0B1612"],
  },
  {
    template: "Template 10",
    hex: ["#458599", "#B57D4D", "#F5F5F5", "#FFFFFF", "#10273C"],
  },
  {
    template: "Template 11",
    hex: ["#1A547A", "#DDC76A", "#D6E6F1", "#FFFFFF", "#2B3442"],
  },
  {
    template: "Template 12",
    hex: ["#763240", "#C19F7F", "#FFFFFF", "#EAEAEA", "#2F2F2F"],
  },
  {
    template: "Template 13",
    hex: ["#4DC5C1", "#EC576B", "#E5E337", "#FFFFFF", "#000000"],
  },
  {
    template: "Template 14",
    hex: ["#B56355", "#6BA17A", "#EBE6EA", "#FFFFFF", "#343733"],
  },
  {
    template: "Template 15",
    hex: ["#01ACAB", "#FEDA3D", "#FAE8E0", "#FFFFFF", "#000000"],
  },
  {
    template: "Template 16",
    hex: ["#926190", "#F3E0CD", "#F9EFE9", "#FFFFFF", "#291528"],
  },
  {
    template: "Template 17",
    hex: ["#478FA2", "#CECECE", "#E8E9E9", "#FFFFFF", "#173F54"],
  },
  {
    template: "Template 18",
    hex: ["#3CC37C", "#E9C893", "#F5F5F5", "#FFFFFF", "#1F3A2A"],
  },
  {
    template: "Template 19",
    hex: ["#01524B", "#1993A3", "#DDDDE6", "#FFFFFF", "#011D1B"],
  },
  {
    template: "Template 20",
    hex: ["#464D77", "#36827F", "#F2F0EC", "#FFFFFF", "#22263C"],
  },
  {
    template: "Template 21",
    hex: ["#4717F6", "#A43ACB", "#FAFAFA", "#FFFFFF", "#0F0A19"],
  },
];

export const PRODUCT_ATTRIBUTE_LINE_KEYS = ["attribute_id", "value_ids"];
export const PRODUCT_VTEX_ATTRIBUTE_LINE_KEYS = ["name", "value"];

export const LEAD_STATUS = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

export const LEAD_PRIORITY = [
  { label: "Low", value: "1" },
  { label: "Medium", value: "2" },
  { label: "High", value: "3" },
];

export const PAYMENT_TERMS = [
  { label: "Immediate Payment", value: 1 },
  { label: "15 Days", value: 2 },
  { label: "21 Days", value: 3 },
  { label: "30 Days", value: 4 },
  { label: "45 Days", value: 5 },
  { label: "2 Months", value: 6 },
  { label: "End of Following Month", value: 7 },
];

export const Title = [
  { label: "Doctor", value: 1 },
  { label: "Madam", value: 2 },
  { label: "Miss", value: 3 },
  { label: "Teacher", value: 4 },
  { label: "Professor", value: 5 },
  { label: "Other", value: 6 },
];

export const Language = [
  { label: "English UK", value: 1 },
  { label: "Arabic", value: 2 },
];
export const PRICE_LIST = [{ label: "Public Pricelist (USD)", value: 1 }];
export const TAX_LIST = [
  { label: "15% Tax", value: 1 },
  { label: "15% Tax", value: 2 },
];

export const PRODUCT_TYPE = [
  { label: "Consumable", value: "consu" },
  { label: "Service", value: "service" },
  { label: "Storable Product", value: "product" },
];

export const CREATE_DATA = "create_date desc"; //newest Data first

// accounting and dashboard
export const COLORS_LIST_SPLINE_CHART = ["#38CB7C", "#FF5837", "#AFAFAF"];

export const CATEGORIES_LIST_SPLINE_CHART = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const DATA_LIST_SPLINE_CHART = [
  {
    name: "Income",
    data: [400, 600, 200, 700, 500, 800, 300, 600, 800, 200, 100, 400],
  },
  {
    name: "Expense",
    data: [200, 300, 400, 100, 600, 300, 500, 700, 300, 100, 400, 200],
  },
  {
    name: "Profit ",
    data: [600, 900, 600, 800, 1100, 1100, 800, 1300, 1100, 300, 500, 600],
  },
];
export const MIN_VALUE_SPLINE_CHART = 0;
export const MAX_VALUE_SPLINE_CHART = 1500;

export const WAREHOUSE_FILTERS_TYPE = {
  "to process": [["state", "in", ["assigned", "partially_available"]]],
  "to waiting": [["state", "in", ["confirmed", "waiting"]]],
  late: [
    "|",
    ["delay_alert_date", "!=", false],
    "&",
    [
      "scheduled_date",
      "<",
      moment().format(SCHEDULE_ACTIVITY_INPUT_DATE_FORMAT),
    ],
    ["state", "in", ["assigned", "waiting", "confirmed"]],
  ],
  backorder_id: [
    "&",
    ["backorder_id", "!=", false],
    ["state", "in", ["assigned", "waiting", "confirmed"]],
  ],
  // "Ready":["state", "in", ["assigned", "partially_available"]]
};

// alternativeproducts list heading
export const alternativeProductsLoadMoreTableHeading = [
  {
    name: "Product Name",
    value: "name",
  },
  {
    name: "Internal Reference",
    value: "default_code",
  },
  {
    name: "Responsible",
    value: "responsible_id.[1]",
    fetchCustomData: (data) => data.responsible_id?.[1],
  },
  {
    name: "Sale Price",
    value: "list_price",
  },
  {
    name: "Cost Price",
    value: "standard_price",
  },
  {
    name: "Quantity",
    value: "qty_available",
  },
  {
    name: "Forecasted Quantity",
    value: "virtual_available",
  },
];

export const ROUTE_LINKS = {
  dashboardRoute: "/homepage/dashboard",
  googleAnalyticsRoute: "/homepage/googleAnalytics",
  crmRoute: "/homepage/crm",
  ordersRoute: "/homepage/orders",
  productsRoute: "/homepage/product",
  contactsRoute: "/homepage/contacts",
  accountingRoute: "/homepage/accounting",
  warehouseRoute: "/homepage/warehouse",
  contactCenterRoute: "/homepage/ContactCenter",
  subscriptionRoute: "/homepage/subscription",
  userRoute: "/homepage/Users",
  companyRoute: "/homepage/company",
  settingRoute: "/homepage/setting",
  designWebsiteRoute: "", // External link
  setupMiniStoreRoute: "/homepage/setup-storefront",
  // brandsRoute: "/homepage/brands",
};
export const SIDEBAR_OPTIONS_LIST = [
  {
    name: "Dashboard",
    link: ROUTE_LINKS.dashboardRoute,
    icon: dashboardIcon,
    showDashboard: false,
    showSideBar: true,
  },
  {
    name: "Google Analytics Report",
    link: ROUTE_LINKS.googleAnalyticsRoute,
    icon: dashboardIcon,
    showDashboard: false,
    showSideBar: true,
  },
  {
    name: "CRM",
    link: ROUTE_LINKS.crmRoute,
    icon: crmIcon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#FFF6F4",
  },
  {
    name: "Orders",
    link: ROUTE_LINKS.ordersRoute,
    icon: orderIcon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#F5FCF9",
  },
  {
    name: "Products",
    link: ROUTE_LINKS.productsRoute,
    icon: productIcon,
    showDashboard: true,
    showSideBar: true,
  },
  {
    name: "Contacts",
    link: "/homepage/contacts",
    icon: contactIcon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#F4F8FF",
  },
  {
    name: "Finance",
    link: ROUTE_LINKS.accountingRoute,
    icon: accountingIcon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#FFFBF1",
  },
  {
    name: "Warehouse",
    link: ROUTE_LINKS.warehouseRoute,
    icon: warehouseIcon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#F4F8FF",
  },
  {
    name: "Contact Center",
    link: ROUTE_LINKS.contactCenterRoute,
    icon: Contactsicon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#FFF6F4",
  },
  {
    name: "iON Subscription",
    link: "/homepage/subscription",
    icon: subscriptionIcon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#F4F8FF",
  },
  {
    name: "Users",
    link: ROUTE_LINKS.userRoute,
    icon: UserImg,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#FFFBF1",
  },
  {
    name: "Company",
    link: ROUTE_LINKS.companyRoute,
    icon: CompanyIcon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#F4F8FF",
  },
  {
    name: "Point of Sale",
    link: "",
    icon: PoSIcon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#F4F8FF",
    openNewPage: true,
  },
  {
    name: "Setting",
    link: ROUTE_LINKS.settingRoute,
    icon: settingIcon,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#FFF6F4",
  },
  {
    name: "Storefront",
    link: "",
    icon: miniStore,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#FFF6F4",
    openNewPage: true,
  },
  {
    name: "Setup Storefront",
    link: ROUTE_LINKS.setupMiniStoreRoute,
    icon: setupMiniStore,
    showDashboard: true,
    showSideBar: true,
    backgroundColor: "#FFF6F4",
  },
];

export const TABLE_CELL_INPUT_MINIMUM_WIDTH = 200;

export const PRODUCT_TEMPLATE_DEFAULT_VALUES = {
  product_variant_count: "",
  is_product_variant: "",
  vtex_product_id: "1",
  VtexAttrsIds: "",
  "VtexAttrsIds.name": "",
  "VtexAttrsIds.value": "",
  attribute_line_ids: "",
  "attribute_line_ids.attribute_id": "1",
  "attribute_line_ids.value_ids": "",
  is_published: "",
  can_post: "",
  show_on_hand_qty_status_button: "",
  qty_available: "",
  uom_name: "",
  virtual_available: "",
  reordering_min_qty: "",
  reordering_max_qty: "",
  nbr_reordering_rules: "",
  sales_count: "",
  id: "",
  image_1920: "",
  __last_update: "",
  related_is_instagram_active: "",
  name: "1",
  sale_ok: "1",
  purchase_ok: "",
  brand_id:"",
  instagram_analytics: "",
  facebook_analytics: "",
  twitter_analytics: "",
  active: "",
  type: "1",
  categ_id: "1",
  default_code: "",
  barcode: "",
  list_price: "",
  pricelist_item_count: "",
  taxes_id: "",
  standard_price: "",
  company_id: "1",
  uom_id: "1",
  uom_po_id: "1",
  currency_id: "",
  cost_currency_id: "",
  product_variant_id: "",
  description: "",
  invoice_policy: "",
  service_type: "",
  visible_expense_policy: "",
  expense_policy: "",
  optional_product_ids: "",
  description_sale: "",
  sale_line_warn: "",
  sale_line_warn_msg: "",
  available_in_pos: "",
  pos_categ_id: "",
  to_weight: "",
  website_url: "",
  website_id: "",
  website_sequence: "",
  public_categ_ids: "",
  inventory_availability: "",
  available_threshold: "",
  custom_message: "",
  alternative_product_ids: "",
  accessory_product_ids: "",
  website_ribbon_id: "",
  supplier_taxes_id: "",
  has_available_route_ids: "",
  route_ids: "",
  route_from_categ_ids: "",
  responsible_id: "",
  weight: "",
  weight_uom_name: "",
  volume: "",
  volume_uom_name: "",
  sale_delay: "",
  hs_code: "",
  tracking: "1",
  property_stock_production: "",
  property_stock_inventory: "",
  packaging_ids: "",
  "packaging_ids.name": "",
  "packaging_ids.qty": "",
  "packaging_ids.product_uom_id": "",
  "packaging_ids.company_id": "",
  description_pickingout: "",
  description_pickingin: "",
  description_picking: "",
  google_categ_id: "",
  brand: "",
  gtin: "",
  mpn: "",
  property_account_income_id: "",
  property_account_expense_id: "",
  asset_category_id: "",
  social_image_1920: "",
  product_template_image_ids: "",
  "product_template_image_ids.id": "",
  "product_template_image_ids.name": "",
  "product_template_image_ids.image_1920": "",
  "product_template_image_ids.sequence": "",
  message_follower_ids: "",
  "message_follower_ids.res_model": "",
  "message_follower_ids.res_id": "",
  "message_follower_ids.partner_id": "",
  "message_follower_ids.channel_id": "",
  activity_ids: "",
  "activity_ids.res_name": "",
  "activity_ids.activity_type_id": "1",
  "activity_ids.summary": "",
  "activity_ids.date_deadline": "",
  message_ids: "",
  "message_ids.date": "",
  "message_ids.subject": "",
  "message_ids.author_id": "",
  "message_ids.model": "",
  "message_ids.res_id": "",
};

export const PRODUCT_INVENTORY_DEFAULT_LIST = [
  "id",
  "tracking",
  "product_id",
  "location_id",
  "lot_id",
  "package_id",
  "owner_id",
  "quantity",
  "inventory_quantity",
  "available_quantity",
  "product_uom_id",
  "currency_id",
  "value",
  "company_id",
];
export const PRODUCT_EXPORT_FIELDS = [
  {
    name: "name",
    label: "Name",
  },
  {
    name: "ProHeight",
    label: "Height",
  },
  {
    name: "ProWidth",
    label: "Width",
  },
  {
    name: "ProLength",
    label: "Length",
  },
  {
    name: "weight",
    label: "weight",
  },
  {
    name: "hs_code",
    label: "HS Code",
  },
  {
    name: "VtexBrand",
    label: "VBrand",
  },
  {
    name: "list_price",
    label: "Sales Price",
  },
  {
    name: "standard_price",
    label: "Cost",
  },
  {
    name: "image_url",
    label: "Image url",
  },
  {
    name: "public_categ_ids",
    label: "Website Product Category",
  },
  {
    name: "qty_available",
    label: "Quantity On Hand",
  },
  {
    name: "product_template_image_ids",
    label: "Extra Product Media",
  },
];

export const CREATE_NEW_CONTACT_RADIO_OPTIONS = [
  {
    label: "Contact",
    value: "contact",
  },
  {
    label: "Invoice Address",
    value: "invoice",
  },
  {
    label: "Delivery",
    value: "delivery",
  },
  {
    label: "Other Address",
    value: "other",
  },
  {
    label: "Private Address",
    value: "private",
  },
];
export const CREATE_NEW_CONTACT_COMPANY_TYPE = [
  {
    label: "Individual",
    value: "person",
  },
  // {
  //   label: "Company",
  //   value: "company",
  // },
];

export const NEW_CONTACT_DEFAULT_FIELDS = {
  same_vat_partner_id: "",
  partner_gid: "",
  additional_info: "",
  opportunity_count: "",
  meeting_count: "",
  sale_order_count: "",
  pos_order_count: "",
  currency_id: "",
  total_invoiced: "",
  payment_token_count: "",
  image_1920: "1",
  __last_update: "",
  is_company: "1",
  commercial_partner_id: "1",
  active: "1",
  company_type: "1",
  name: "1",
  parent_id: "1",
  company_name: "1",
  type: "1",
  street: "",
  street2: "",
  city: "",
  state_id: "1",
  zip: "1",
  country_id: "1",
  vat: "1",
  function: "",
  phone_blacklisted: "",
  mobile_blacklisted: "",
  phone: "1",
  mobile: "1",
  phone_sanitized: "1",
  user_ids: "",
  is_blacklisted: "",
  email: "1",
  website: "",
  title: "",
  active_lang_count: "",
  lang: "1",
  category_id: "",
  bank_ids: "",
  "bank_ids.sequence": "",
  "bank_ids.bank_id": "",
  "bank_ids.acc_number": "",
  "bank_ids.acc_holder_name": "",
  "bank_ids.branch_name": "",
  "bank_ids.cr_img": "",
  child_ids: "",
  "child_ids.id": "",
  "child_ids.color": "",
  "child_ids.name": "1",
  "child_ids.title": "",
  "child_ids.type": "1",
  "child_ids.email": "1",
  "child_ids.parent_id": "1",
  "child_ids.is_company": "1",
  "child_ids.function": "",
  "child_ids.phone": "1",
  "child_ids.street": "",
  "child_ids.street2": "",
  "child_ids.zip": "1",
  "child_ids.city": "",
  "child_ids.country_id": "1",
  "child_ids.mobile": "1",
  "child_ids.state_id": "1",
  "child_ids.image_128": "",
  "child_ids.lang": "1",
  "child_ids.comment": "",
  "child_ids.display_name": "1",
  "child_ids.company_id": "1",
  "child_ids.image_1920": "1",
  "child_ids.__last_update": "",
  "child_ids.user_id": "",
  user_id: "",
  property_delivery_carrier_id: "",
  team_id: "",
  property_payment_term_id: "",
  property_product_pricelist: "",
  property_supplier_payment_term_id: "",
  property_payment_method_id: "",
  barcode: "",
  property_account_position_id: "",
  ref: "",
  company_id: "1",
  website_id: "",
  industry_id: "",
  property_stock_customer: "",
  property_stock_supplier: "",
  property_account_receivable_id: "",
  property_account_payable_id: "",
  active_limit: "",
  enable_credit_limit: "",
  warning_stage: "",
  blocking_stage: "",
  comment: "",
  sale_warn: "",
  sale_warn_msg: "",
  invoice_warn: "",
  invoice_warn_msg: "",
  picking_warn: "",
  picking_warn_msg: "",
  message_follower_ids: "",
  "message_follower_ids.res_model": "",
  "message_follower_ids.res_id": "",
  "message_follower_ids.partner_id": "",
  "message_follower_ids.channel_id": "",
  activity_ids: "",
  "activity_ids.res_name": "",
  "activity_ids.activity_type_id": "1",
  "activity_ids.summary": "",
  "activity_ids.date_deadline": "",
  message_ids: "",
  "message_ids.date": "",
  "message_ids.subject": "",
  "message_ids.author_id": "",
  "message_ids.model": "",
  "message_ids.res_id": "",
};

export const CONTACT_DETAIL_FIELDS_LIST = [
  "same_vat_partner_id",
  "opportunity_count",
  "meeting_count",
  "sale_order_count",
  "pos_order_count",
  "currency_id",
  "total_invoiced",
  "payment_token_count",
  "is_published",
  "image_1920",
  "__last_update",
  "is_company",
  "commercial_partner_id",
  "active",
  "company_type",
  "name",
  "parent_id",
  "company_name",
  "type",
  "street",
  "street2",
  "city",
  "state_id",
  "zip",
  "country_id",
  "vat",
  "function",
  "phone_blacklisted",
  "mobile_blacklisted",
  "phone",
  "mobile",
  "phone_sanitized",
  "user_ids",
  "is_blacklisted",
  "email",
  "website",
  "title",
  "active_lang_count",
  "lang",
  "category_id",
  "has_service",
  "bank_ids",
  "child_ids",
  "user_id",
  "property_delivery_carrier_id",
  "team_id",
  "property_payment_term_id",
  "property_product_pricelist",
  "property_supplier_payment_term_id",
  "property_payment_method_id",
  "barcode",
  "property_account_position_id",
  "ref",
  "company_id",
  "website_id",
  "industry_id",
  "property_stock_customer",
  "property_stock_supplier",
  "property_account_receivable_id",
  "property_account_payable_id",
  "active_limit",
  "enable_credit_limit",
  "warning_stage",
  "blocking_stage",
  "comment",
  "display_name",
];

export const ONCHANGE_CONTACT_COMPANY_FIELDS = {
  street: "",
  street2: "",
  city: "",
  state_id: "1",
  zip: "1",
  country_id: "1",
  parent_id: "1",
};

export const PRODUCT_TYPE_LIST = [
  {
    label: "Consumable",
    value: "consu",
  },
  {
    label: "Service",
    value: "service",
  },
  {
    label: "Storable Product",
    value: "product",
  },
  {
    label: "Ion Subscription",
    value: "subscription",
  },
];
export const SELLER_GROUP_LIST = [
  {
    label: "Consignment Ship",
    value: "b753d995e4584d3f9c7cc96508cac449",
  },
  {
    label: "Drop Ship",
    value: "10cf65d9f9074a12b7cf8dcb1ffae684",
  },
];
export const SELLER_GROUP_TAXES_LIST = [
  {
    label: "VAT",
    value: "e5c1f4b89364431ba42001d00e67fde2",
  },
  {
    label: "Non-VAT",
    value: "fce795e458ec4e54be96edbf21f3800b",
  },
];
